import { UPDATE_TRANSCRIPT_MODAL, UPDATE_CONFIRMATION_MODAL, ASK_VYRILL_INTRO_MODAL } from "./Actions";

const _nullState = {
  videoTranscript: {
    shouldOpen: false,
    videoId: "",
    videoStartAt: 0,
    pinSentence: "",
    pinTime: 0,
  },

  confirmationProcess: {
    shouldOpen: false,
    message: "",
  },
  //   other modals
  askVyrillIntro:{
    showIntro:false
  }
};

const modalsState = (state = _nullState, payload = {}) => {
  const { type, data } = payload;
  switch (type) {
    case UPDATE_TRANSCRIPT_MODAL:
      return {
        ...state,
        videoTranscript: { ...state.videoTranscript, ...data },
      };

    case UPDATE_CONFIRMATION_MODAL:
      return {
        ...state,
        confirmationProcess: { ...state.confirmationProcess, ...data },
      };

    case ASK_VYRILL_INTRO_MODAL:
      return {
        ...state,
        askVyrillIntro: { ...state.askVyrillIntro, ...data },
      };

    default:
      return state;
  }
};

export default modalsState;
